<template>
  <div class="news-all">
    <div class="title">
      <span class="time">
        01.18
        <br />2019
      </span>
      <span class="tiel">美菜网喜获金牛角2018新零售创新标杆奖</span>
    </div>
    <div class="mat-content">
      <div class="tet-js">
        前不久，2018年度金牛角案例盛典暨颁奖礼由中国人民大学商学院和“移动创意工场”速途网络联合发起，并且在中国人民大学进行举办。美菜网在这场角逐中，凭借优质的服务以及商品，加上创新的新农业运营模式，在300多家企业中脱颖而出，成为了最大赢家，拿下了“金牛角2018新零售创新标杆奖”。
        <br />
        <br />本次“金牛角”案例盛典以“新营销新爆点”为主题，围绕互动、创意、创新、社交、IP、粉丝等议题。参评企业包含新零售、电商、综艺、新媒体、实体企业等300多个。经过层层筛选，最终来自网易、德邦、TCL集团、京东、美团点评、统一企业(中国)等33家企业案例脱颖而出，评选出整合营销、品牌传播力、品牌IP、新营销、新零售等八大类别的奖项。
        <br />
        <br />
      </div>

      <!-- <div class="title-bold"><span></span>20年里的朴实无华</div> -->

      <p align="center">
        <img src="@/assets/images/new-img/b011_1.jpeg" width="640" />
      </p>
      <div class="tet-js" style="text-align: center">牛角2018新零售创新标杆奖现场</div>
      <div class="tet-js">
        美菜网作为中国餐饮供应链杰出服务商，其通过自主研发移动电商平台，自建仓储、物流、配送体系，创新升级了农产品供应链。其“两端一链一平台”的新零售模式，一端链接田间地头，一端链接城市餐桌，实现农产品从地头到餐桌高速的流通。目前，业务覆盖超220个城市，累计服务超过商户270万家。给很多农民和商家留下了“买菜买菜上美菜”的品牌印象。
        <br />
        <br />
      </div>
      <p align="center">
        <img src="@/assets/images/new-img/b011_2.jpeg" width="640" />
      </p>
      <div class="tet-js" style="text-align: center">美菜网荣获金牛角2018新零售创新标杆奖</div>
      <div class="tet-js">
        一方面，美菜网通过这一模式，希望给餐饮商家带来“价格无忧，选择无忧，品类无忧，服务无忧”的无忧体验。让餐厅拥有稳定的供货渠道，产品售后有了保障，既大大地降低了餐饮行业的采购成本，也减少了企业的运营风险。另一方面，对于上游农民来说，他们可以利用美菜网自主研发的大数据系统，一键了解农产品价格走向。美菜网为他们提供了经营管理及决策服务，准确的将市场需求反馈给农民，从源头指导农民生产、建立产地标准，避免了农产品货不对市的问题，帮农民增产增收。
        <br />
        <br />不仅在模式上做了创新，美菜网还将解决农产品滞销问题做到深入。推出的"美菜SOS精准扶贫全国采购计划"，帮助滞销农民拓宽销售渠道，让陷入绝望的滞销菜农重燃起希望。通过建立农产品应急救助中心，积极为贫困地区、滞销地区分销农产品，进行渠道扶贫，助力贫困地区农产品走出来，扶贫到穷根上。
        <br />
        <br />自2017年以来，"美菜SOS精准扶贫全国采购计划"足迹遍及全国22个地区，采购滞销农产品总量2653.4万斤。其中，仅环京津34个贫困地区的农产品采购总量就达到8306.2万斤。
        <br />
        <br />以上的数据不仅仅展示了美菜网的实力，也展示了美菜网为大家服务的那颗心，也正是这些原因，让美菜网在金牛角2018新零售创新标杆奖中拔得头筹，在一定程度上，也促使了美菜网做大做强，让美菜网更广泛的服务于社会大众。
        <br />
        <br />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "new-a1"
};
</script>

<style lang="scss" scoped>
</style>
